import { useContext } from 'react';
import { AuthContext } from '../contexts/auth-context';

/**
 * Custom hook to access the authentication context.
 * Provides access to user data, authentication state, and authentication methods.
 * 
 * @returns The auth context containing session, user profile, and auth methods
 * @throws Error when used outside of AuthProvider
 */
export const useAuth = () => {
  const context = useContext(AuthContext);
  
  if (context === undefined) {
    console.error('useAuth: No AuthContext found - component is likely outside of AuthProvider');
    throw new Error('useAuth must be used within an AuthProvider');
  }
  
  return context;
}; 